import {RegulationComponentsCommon} from "../../regulation-components-common";
import {AboutComponentProps} from "../../../../components/about-component/about.component";

export class PortugalRegulationComponents extends RegulationComponentsCommon {
    protected async _getAboutDialogProps(): Promise<AboutComponentProps> {
        const props = await super._getAboutDialogProps();
        const sessionBalance = await this.services.user.getOpenSessionsRealMoneyBalance();
        return {
            ...props,
            openSessionsBalance: sessionBalance
        };
    }
}